module.exports = __webpack_public_path__ + "static/img/Simple-Line-Icons.2fe2efe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SimpleLineIcons/Simple-Line-Icons.svg?v=2.4.0
// module id = 1170
// module chunks = 5